export const GET_ALL_REFERRALS = "GET_ALL_REFERRALS";
export const GET_ALL_REFERRALS_START = "GET_ALL_REFERRALS_START";
export const GET_ALL_REFERRALS_FAILED = "GET_ALL_REFERRALS_FAILED";

export const RELOAD_PAGE_RESET = "RELOAD_PAGE_RESET";